
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    $modelViewer = this.querySelector('model-viewer')

    constructor() {
      super();

      this.modelViewerTrackListener()
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }

    modelViewerTrackListener () {
      // this.$modelViewer?.addEventListener('load', () => {
      //   console.log('LOADED')
      // })

      // this.$modelViewer?.addEventListener('camera-change', () => {
      //   console.log('camera-change')
      // })

      const dataLayerPush = () => {
        try {
          window._arrEvent_3d_model = window._arrEvent_3d_model || []
          window.dataLayer = window.dataLayer || []
          const currentVariantId = new URLSearchParams(window.location.search).get('variant') || window.variantsData.first_variant_id
          const currentVariantModelButtonId = window.variantsData[currentVariantId.toString()].model_button_id
          window._arrEvent_3d_model.push({
            event: '3d_model_interaction',
            color: currentVariantModelButtonId || ''
          })
          // 标记完成互动，需要互动次数≥3，上报一次
          if (window._arrEvent_3d_model.filter(item => item.event === '3d_model_interaction' && item.color === currentVariantModelButtonId).length === 2) {
            window.dataLayer.push({
              event: '3d_model_interaction',
              color: currentVariantModelButtonId || ''
            })
          }
        } catch (error) {}
      }

      // pc: 点击 拖拽 / 移动端: 点击 滑动 缩放
      let startInput = false
      const onPointerDown = () => {
        if (startInput === false) {
          window.addEventListener('pointerup', onPointerUp)
        }

        startInput = true
      }
      const onPointerUp = () => {
        dataLayerPush()
        startInput = false
        window.removeEventListener('pointerup', onPointerUp)
      }
      this.$modelViewer?.addEventListener('pointerdown', onPointerDown)

      const onWheel = this.debounce(() => {
        dataLayerPush()
      }, 200)
      this.$modelViewer?.addEventListener('wheel', onWheel)
    }

    debounce (fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
